import { useTranslation } from 'react-i18next'
import { motion } from 'motion/react'
import refBirkenhof from '../assets/ref-birkenhof.webp'
import refMariaJussel from '../assets/ref-maria-jussel.webp'
import refPhysiomed from '../assets/ref-physiomed.webp'
import refHelvetia from '../assets/ref-helvetia.webp'
import refDamuels from '../assets/ref-damuels-magazine.webp'
import refJeanJacques from '../assets/ref-jean-jacques.webp'

export default function References() {
  const { t } = useTranslation()

  return (
    <section id="references" className="bg-sand py-20 px-6">
      {/* Header */}
      <motion.div
        initial={{ opacity: 0, y: 30 }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true, amount: 0.3 }}
        transition={{ duration: 0.6 }}
        className="text-center mb-16"
      >
        <p className="font-body text-rot text-xs tracking-widest uppercase mb-3">
          {t('referenzen.kicker')}
        </p>
        <h2 className="font-headline text-espresso text-4xl md:text-5xl mb-6">
          {t('referenzen.h2')}
        </h2>
        <p className="font-body text-espresso/70 text-base leading-relaxed max-w-2xl mx-auto">
          {t('referenzen.intro')}
        </p>
      </motion.div>
      {/* Projekt Grid */}
      <div className="max-w-5xl mx-auto grid grid-cols-1 md:grid-cols-2 gap-6 mb-8">
        {[
          {
            src: refBirkenhof,
            key: 0,
            link: 'https://www.birkenhof-oberstaufen.de',
          },
          {
            src: refMariaJussel,
            key: 3,
            link: 'https://mariajussel.coach/',
          },
          {
            src: refPhysiomed,
            key: 2,
            link: 'https://physiomed-eislingen.de/',
          },
          {
            src: refHelvetia,
            key: 1,
            link: 'https://www.hotel-helvetia.com/',
          },
          {
            src: refDamuels,
            key: 4,
            link: 'https://www.damuels.at/de/prospekte/prospektbestellung.html',
          },
          {
            src: refJeanJacques,
            key: 5,
            objectPosition: 'center 70%',
            link: 'https://www.jeanundjacques.com/',
          },
        ].map((project, i) => {
          const p = t(`referenzen.projects.${project.key}`, { returnObjects: true }) as {
            name: string
            category: string
          }
          const image = (
            <div className="relative rounded-xl overflow-hidden shadow-md">
              <img
                src={project.src}
                alt={p.name}
                loading="lazy"
                width={1920}
                height={1080}
                className="w-full h-48 sm:h-64 object-cover group-hover:scale-105 transition-transform duration-500"
                style={
                  project.objectPosition ? { objectPosition: project.objectPosition } : undefined
                }
              />
            </div>
          )
          return (
            <div key={i} className="group relative">
              {project.link ? (
                <a
                  href={project.link}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="block cursor-pointer"
                >
                  {image}
                </a>
              ) : (
                image
              )}
              <div className="mt-3 px-1">
                <h3 className="font-headline text-espresso text-lg font-medium">{p.name}</h3>
                <p className="font-body text-espresso/75 text-sm mt-0.5">{p.category}</p>
              </div>
            </div>
          )
        })}
      </div>
    </section>
  )
}
